import { Route } from 'react-router-dom'
import { PageLayout } from 'containers'

import { Routes } from '../Routes'

import { BarflyRouter } from './Barfly'

import { DashRouter } from './Dash'

import { PinmonkeyRouter } from './Pinmonkey'

import { KaraokeRouter } from './Karaoke'

import { TriviaRouter } from './Trivia'

export * from './guestGameRouter'

export const GameRouter = () => {
  return (
    <Routes>
      <Route path="dash/*" element={<DashRouter />} />
      <Route path="/*" element={<PageLayout />}>
        <Route path="karaoke/*" element={<KaraokeRouter />} />
        <Route path="trivia/*" element={<TriviaRouter />} />
        <Route path="barfly/*" element={<BarflyRouter />} />
        <Route path="dungeon/*" element={<PinmonkeyRouter />} />
      </Route>
    </Routes>
  )
}
